import React, { FC } from 'react';

// Models
import { CgiProgressStatusType, CgiProvider } from '../../../models/CGI/CGI';

// Components
import { CircleLoader } from '../../common';

// Utils
import { getCgiProviderName } from '../../../utilities/cgi';

// i18n
import { useTranslation } from '../../../translations/useTranslation';

interface Props {
  provider: CgiProvider;
  progressStatus?: CgiProgressStatusType;
  autoStartToken?: string;
}

const CgiSameDevice: FC<Props> = ({
  progressStatus,
  provider,
  autoStartToken
}) => {
  const { m, keys } = useTranslation();
  const providerName = getCgiProviderName(provider);
  const getAutoStartLink = (
    autoStartToken: string,
    provider: CgiProvider
  ): string | undefined => {
    switch (provider) {
      case 'freja':
        return `frejaeid://bindUserToTransaction?transactionReference=${autoStartToken}&originAppScheme=null`;
      case 'bankid':
        return `bankid:///?autostarttoken=${autoStartToken}&redirect=null`;
      default:
        return undefined;
    }
  };

  return (
    <div>
      <p>{m(keys.cgiMobileInstructions, '{provider}', providerName)}</p>
      <CircleLoader size="sm" />
      {autoStartToken && progressStatus !== CgiProgressStatusType.USER_SIGN && (
        <div>
          <a
            className="button autostart-button"
            href={getAutoStartLink(autoStartToken, provider)}
          >
            {m(keys.cgiAutostartButtonText, '{provider}', providerName)}
          </a>
        </div>
      )}
    </div>
  );
};

export default CgiSameDevice;
